import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id CDCF29D7-CED3-45DB-BBC8-ACEA8262738C
 * name book-remove-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-remove-outline.svg
 * tags
 */
export const BookRemoveOutlineIcon = createSvgIcon(<><path d="M13.09 20C13.21 20.72 13.46 21.39 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V4H13V12L10.5 9.75L8 12V4H6V20H13.09M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z" /></>, 'BookRemoveOutlineIcon');
export default BookRemoveOutlineIcon